import { Container } from '@mui/material';
import MaintenanceBannerDetails from '../Settings/MaintenanceBannerDetails';

export default function MaintenanceBannerAdmin() {
  return (
    <Container maxWidth="xl" sx={{ px: 4, mt: 4, mb: 4 }}>
      <MaintenanceBannerDetails />
    </Container>
  );
}
